import React from 'react';
import {
    SetItemListContainer,
    StyledDivMessage,
    Header,
    MainSectionFlex,
    DropDownStyle,
    StyledDiv,
    SetItemCardContainer,
    MainSegmentSection,
} from './SetDetails.styled';
import CondensedMobileView from 'src/common/refactoredComponents/condensedMobileView/CondensedMobileView';
import Select from 'src/common/refactoredComponents/select/Select';
import TabControl from 'src/common/refactoredComponents/tabControl/tabControl';
import { checkConditionsNoItems } from 'src/utils/util';
import ListView from 'src/common/organisms/listView/index.jsx';
import {isLandscape} from 'src/utils/util';
import {DARK_GRAY_FONT_COLOR} from 'src/styles/fonts/MCFontConstants';

const SetItemDetailsCondensedList = ({
    isCondensedView,
    data,
    sizes,
    t,
    isMobileDevice,
    isLanguageChanged,
    sortIconSelectionValue,
    sortValue,
    ProductDetailsFilter,
    handleListFilter,
    onOpen,
    onClose,
    onItemClick,
    isOnlyPlusButton,
    onAddClick,
    relatedSortOption,
    sortedRelatedValue,
    hideSortDropdown,
    isEquity,
    selectedSegment,
    setSelectedSegment,
    isSetDetail,
}) => {
    const setData = isSetDetail ? data?.billOfMaterials : data?.foundInSets;

    if (
        !(isCondensedView && (setData?.length || data?.relatedProducts?.length))
    )
        return null;

    return (
        <>
            {isCondensedView && window.innerWidth > sizes.mobileDevice && (
                <SetItemListContainer
                    id={isSetDetail ? 'items' : 'found-in-sets'}
                    isCondensedView={isCondensedView}
                >
                    {/* Sets Section */}
                    {setData?.length > 0 &&
                    setData.some((item) => item.message) ? (
                        <StyledDivMessage>
                            <Header
                                marginBottom={'5px'}
                                mbPaddingLeft={'20px'}
                                mbWidth={'calc(100%)'}
                                paddingLeft={'20px'}
                                height={'38px'}
                                mbHeight={'33px'}
                            >
                                {isSetDetail
                                    ? t('common.itemsLabel')
                                    : t(
                                          'scheduleSurgery.itemDetails.foundInSets'
                                      )}{' '}
                                (
                                {isSetDetail
                                    ? data?.billOfMaterials?.some(
                                          (item) => item.message
                                      )
                                        ? 0
                                        : data?.billOfMaterials?.length
                                    : data?.foundInSets?.some(
                                          (item) => item.message
                                      )
                                    ? 0
                                    : data?.foundInSets?.length}
                                )
                            </Header>
                            {setData.map((item, index) => (
                                <StyledDiv margin={'0px 0px'} key={index}>
                                    {item.message}
                                </StyledDiv>
                            ))}
                        </StyledDivMessage>
                    ) : (
                        <>
                            <MainSectionFlex>
                                <Header
                                    marginBottom={'5px'}
                                    mbPaddingLeft={'20px'}
                                    mbWidth={'calc(100%)'}
                                    paddingLeft={'20px'}
                                    height={'38px'}
                                    mbHeight={'33px'}
                                    width={'99%'}
                                >
                                    {isSetDetail
                                        ? t('common.itemsLabel')
                                        : t(
                                              'scheduleSurgery.itemDetails.foundInSets'
                                          )}{' '}
                                    (
                                    {isSetDetail
                                        ? checkConditionsNoItems(
                                              data?.billOfMaterials
                                          )
                                            ? data?.billOfMaterials?.length
                                            : 0
                                        : data?.foundInSets?.some(
                                              (item) => item.message
                                          )
                                        ? 0
                                        : data?.foundInSets?.length}
                                    )
                                    <DropDownStyle
                                        width={
                                            isLandscape() && isMobileDevice()
                                                ? '330px'
                                                : isMobileDevice()
                                                ? '100%'
                                                : isLanguageChanged &&
                                                  !isMobileDevice() &&
                                                  isCondensedView
                                                ? '180px'
                                                : isCondensedView &&
                                                  !isMobileDevice()
                                                ? '330px'
                                                : ''
                                        }
                                        marginLeft={'65%'}
                                    >
                                        <Select
                                            id="common-setItemDetailsCondensedList-setItemDetails-setData"
                                            sortMarginRight={
                                                isCondensedView &&
                                                isMobileDevice()
                                            }
                                            isSortMobileView={
                                                isCondensedView &&
                                                isMobileDevice()
                                            }
                                            borderRadius={'6px'}
                                            selectedLabelFontSize={'14px'}
                                            isFromConsignmentAddProductGuide={
                                                isCondensedView && true
                                            }
                                            sortIcon={sortIconSelectionValue}
                                            value={sortValue}
                                            options={ProductDetailsFilter()}
                                            onChange={handleListFilter}
                                            placeholder={t('common.selectText')}
                                            optionValue="id"
                                            optionLabel={'title'}
                                            onOpen={onOpen}
                                            onClose={onClose}
                                        />
                                    </DropDownStyle>
                                </Header>
                            </MainSectionFlex>

                            <ListView
                                id={isSetDetail ? 'items' : 'found-in-sets'}
                                products={setData}
                                handleSetItemClick={onItemClick}
                                setProductToBeAdded={onAddClick}
                                isForSetItem={true}
                                isOnlyPlusButton={isOnlyPlusButton}
                                isFromSetItemDetailsLists={true}
                            />
                        </>
                    )}

                    {/* Related Section */}
                    {data?.relatedProducts?.length > 0 &&
                    data?.relatedProducts.some((item) => item.message) ? (
                        <StyledDivMessage>
                            <Header
                                marginBottom={'5px'}
                                mbPaddingLeft={'20px'}
                                mbWidth={'calc(100%)'}
                                paddingLeft={'20px'}
                                height={'38px'}
                                mbHeight={'33px'}
                            >
                                {t('common.relatedText')} (
                                {data?.relatedProducts.length - 1})
                            </Header>
                            {data?.relatedProducts.map((item, index) => (
                                <StyledDiv margin={'0px 0px'} key={index}>
                                    {item.message}
                                </StyledDiv>
                            ))}
                        </StyledDivMessage>
                    ) : (
                        <>
                            <Header
                                marginBottom={'5px'}
                                mbPaddingLeft={'20px'}
                                mbWidth={'calc(100%)'}
                                paddingLeft={'20px'}
                                height={'38px'}
                                mbHeight={'33px'}
                                margin={'10px 0px 10px 5px'}
                            >
                                {t('common.relatedText')} (
                                {data?.relatedProducts?.length || 0})
                                {hideSortDropdown ? (
                                    <DropDownStyle
                                        width={isCondensedView && 'auto'}
                                        marginLeft={'65%'}
                                        isCondensedView={isCondensedView}
                                    >
                                        <Select
                                            hideClear
                                            id="common-setItemDetailsCondensedList-setItemDetails-relatedText"
                                            selectedLabelFontSize={'14px'}
                                            borderRadius={'6px'}
                                            sortIcon={sortIconSelectionValue}
                                            value={sortedRelatedValue}
                                            options={relatedSortOption}
                                            onChange={handleListFilter}
                                            placeholder={t('common.selectText')}
                                            optionValue="id"
                                            optionLabel={'title'}
                                            onOpen={onOpen}
                                            onClose={onClose}
                                            height={isCondensedView && '40px'}
                                        />
                                    </DropDownStyle>
                                ) : null}
                            </Header>

                            <ListView
                                id={data?.relatedProducts}
                                products={data?.relatedProducts}
                                handleSetItemClick={onItemClick}
                                setProductToBeAdded={onAddClick}
                                isForSetItem={true}
                                isOnlyPlusButton={isOnlyPlusButton}
                                isFromSetItemDetailsLists={true}
                            />
                        </>
                    )}
                </SetItemListContainer>
            )}

            {/* Mobile/Tablet Condensed View */}
            {window.innerWidth < 500 && isCondensedView && (
                <>
                    <MainSegmentSection id="setItemDetails-main-segment-section">
                        <TabControl
                            widthForMobileScreen={'95% !important'}
                            marginLeftForSetItemDetail={'2%'}
                            isCondensedView={isCondensedView}
                            tabOneTitle={
                                isSetDetail
                                    ? t('common.itemsLabel')
                                    : t('scheduleSurgery.itemDetails.foundInSets')
                            }
                            tabOneNumber={
                                isSetDetail
                                    ? data?.billOfMaterials?.some(item => item.message)
                                        ? 0
                                        : data?.billOfMaterials?.length
                                    : data?.foundInSets?.some(item => item.message)
                                    ? 0
                                    : data?.foundInSets?.length
                            }
                            tabTwoTitle={t('common.relatedText')}
                            tabTwoNumber={
                                !data.relatedProducts.some(item => item.message)
                                    ? data.relatedProducts.length
                                    : 0
                            }
                            tabOneId="common-setItemDetailsCondensed-foundInSets"
                            tabTwoId="common-setItemDetailsCondensed-relatedProducts"
                            tabViewWidth={isSetDetail ? '235px !important' : '280px !important'}
                            tabViewHeight={ '40px'}
                            tabFontFamily={'AvenirNextWorld Demi'}
                            tabViewMargin={'auto'} 
                            tabFontSize={
                                isCondensedView && window.innerWidth < 500
                                    ? '14px'
                                    : '16px'
                            }
                            tabFontColor={DARK_GRAY_FONT_COLOR}
                            selectedTabState={val => setSelectedSegment(val.toString())}
                            tabOneChildren={
                                <>
                                    <DropDownStyle
                                        width={
                                            isMobileDevice()
                                                ? '100% !important'
                                                : isLanguageChanged &&
                                                  !isMobileDevice() &&
                                                  isCondensedView
                                                ? '180px'
                                                : isCondensedView &&
                                                  !isMobileDevice()
                                                ? '330px'
                                                : ''
                                        }
                                        marginLeft={'65%'}
                                        isCondensedView={isCondensedView}
                                    >
                                        <Select
                                            id="common-setItemDetailsCondensedList-setItemDetails-title"
                                            hideClear
                                            sortMarginRight={
                                                isCondensedView &&
                                                isMobileDevice()
                                            }
                                            isSortMobileView={
                                                isCondensedView &&
                                                isMobileDevice()
                                            }
                                            borderRadius={'6px'}
                                            selectedLabelFontSize={'14px'}
                                            isFromConsignmentAddProductGuide={
                                                isCondensedView && true
                                            }
                                            sortIcon={sortIconSelectionValue}
                                            value={sortValue}
                                            options={ProductDetailsFilter()}
                                            onChange={handleListFilter}
                                            placeholder={t('common.selectText')}
                                            optionValue="id"
                                            optionLabel={'title'}
                                            onOpen={onOpen}
                                            onClose={onClose}
                                        />
                                    </DropDownStyle>
                                    <SetItemCardContainer
                                        scrollBarBackgroundColor={'#808080'}
                                        scrollBarBackGroundColorOnHover={'#00000029'}
                                        height={'auto'}
                                    >
                                        {setData?.map((item, index) =>
                                            item.message ? (
                                                <StyledDiv
                                                    margin={'0px 0px'}
                                                    key={item.cfn || index}
                                                >
                                                    {item.message}
                                                </StyledDiv>
                                            ) : (
                                                <CondensedMobileView
                                                    showCheckBox={false}
                                                    background={
                                                        index % 2 !== 0
                                                            ? '#f5f5f5cc'
                                                            : ''
                                                    }
                                                    isProductDetails={true}
                                                    isOnlyPlusButton={
                                                        isOnlyPlusButton
                                                    }
                                                    addCard={() =>
                                                        onAddClick(item)
                                                    }
                                                    isCounterButton={true}
                                                    isSetDetailPage={true}
                                                    setOrItemDetails={item}
                                                    marginOnMediumDevice={
                                                        '10px 0 0 2px'
                                                    }
                                                    marginOnLargeDevice={
                                                        '10px 2px 0 0'
                                                    }
                                                    marginOnMobileDevice={'0'}
                                                    key={`${
                                                        item.cfn || index
                                                    }-set`}
                                                    minWidth={'99%'}
                                                    itemQuantity={item}
                                                    showType={true}
                                                    onSetItemClick={onItemClick}
                                                    showBrand={true}
                                                    productSearchFlag={true}
                                                    productType={'Cart'}
                                                    setIsQuantityMoreThan50={
                                                        true
                                                    }
                                                    description={
                                                        item.description
                                                    }
                                                    clickable={true}
                                                    cardType={'items'}
                                                    margin={'0 3px'}
                                                    setNameColor="#1010EB"
                                                    setNameFontSizeMobile="15px"
                                                    setNameFontSizeDesktop="15px"
                                                    itemCardsContainerMinMobWidth={
                                                        '95%'
                                                    }
                                                    isCart={true}
                                                    marginRight={'-14px'}
                                                    width={'100%'}
                                                    minHeight={'0px'}
                                                    isEquity={isEquity}
                                                    selectedSegment={
                                                        selectedSegment
                                                    }
                                                />
                                            )
                                        )}
                                    </SetItemCardContainer>
                                </>
                            }
                            tabTwoChildren={
                                <>
                                    <DropDownStyle
                                        width={isCondensedView && 'auto'}
                                        isCondensedView={isCondensedView}
                                        marginLeft={'65%'}
                                    >
                                        <Select
                                            id="common-setItemDetailsCondensedList-setItemDetails-selectText"
                                            selectedLabelFontSize={'14px'}
                                            borderRadius={'6px'}
                                            hideClear
                                            sortIcon={sortIconSelectionValue}
                                            value={sortedRelatedValue}
                                            options={relatedSortOption}
                                            onChange={handleListFilter}
                                            placeholder={t('common.selectText')}
                                            optionValue="id"
                                            optionLabel={'title'}
                                            onOpen={onOpen}
                                            onClose={onClose}
                                            height={isCondensedView && '40px'}
                                        />
                                    </DropDownStyle>
                                    <SetItemCardContainer
                                        scrollBarBackgroundColor={'#808080'}
                                        scrollBarBackGroundColorOnHover={'#00000029'}
                                        height={
                                            data?.relatedProducts?.length > 2
                                                ? '300px'
                                                : 'auto'
                                        }
                                    >
                                        {data?.relatedProducts && data?.relatedProducts.length > 0 ? (
                                            data?.relatedProducts.map((item, index) =>
                                                item.message ? (
                                                    <StyledDiv
                                                        margin={'0px 0px'}
                                                        key={index}
                                                    >
                                                        {item.message}
                                                    </StyledDiv>
                                                ) : (
                                                    <CondensedMobileView
                                                        showCheckBox={false}
                                                        background={
                                                            index % 2 !== 0
                                                                ? '#f5f5f5cc'
                                                                : ''
                                                        }
                                                        isProductDetails={true}
                                                        isOnlyPlusButton={
                                                            isOnlyPlusButton
                                                        }
                                                        addCard={() =>
                                                            onAddClick(item)
                                                        }
                                                        isCounterButton={true}
                                                        isSetDetailPage={true}
                                                        setOrItemDetails={item}
                                                        marginOnMediumDevice={
                                                            '10px 0 0 2px'
                                                        }
                                                        marginOnLargeDevice={
                                                            '10px 2px 0 0'
                                                        }
                                                        marginOnMobileDevice={'0'}
                                                        key={`${
                                                            item.cfn ||
                                                            index
                                                        }-related`}
                                                        minWidth={'99%'}
                                                        itemQuantity={item}
                                                        showType={true}
                                                        onSetItemClick={onItemClick}
                                                        showBrand={true}
                                                        productSearchFlag={true}
                                                        productType={'Cart'}
                                                        setIsQuantityMoreThan50={
                                                            true
                                                        }
                                                        description={
                                                            item.description
                                                        }
                                                        clickable={true}
                                                        cardType={'items'}
                                                        margin={'0 3px'}
                                                        setNameColor="#1010EB"
                                                        setNameFontSizeMobile="15px"
                                                        setNameFontSizeDesktop="15px"
                                                        itemCardsContainerMinMobWidth={
                                                            '95%'
                                                        }
                                                        isCart={true}
                                                        width={'100%'}
                                                        minHeight={'0px'}
                                                        isEquity={isEquity}
                                                        selectedSegment={
                                                            selectedSegment
                                                        }
                                                    />
                                                )
                                            )
                                        ) : (
                                            <StyledDiv margin={'0px 0px'}>
                                                {t('common.noItemsFound')}
                                            </StyledDiv>
                                        )}
                                    </SetItemCardContainer>
                                </>
                            }
                            marginTop={isSetDetail ? '0px' : '10px'}
                            marginLeft={'10px'}
                        />
                    </MainSegmentSection>
                </>
            )}
        </>
    );
};

export default SetItemDetailsCondensedList;
